import { render, staticRenderFns } from "./StudentsList.vue?vue&type=template&id=a6292b6a&scoped=true&"
import script from "./StudentsList.vue?vue&type=script&lang=js&"
export * from "./StudentsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6292b6a",
  null
  
)

export default component.exports